module.exports = __webpack_public_path__ + "static/JG1-dba96ddba7309193b82f497f8c6cf3c2.png";